import { render, staticRenderFns } from "./index.vue?vue&type=template&id=525bfe1e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutSitemap: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/layout/sitemap.vue').default})
